/* globals localStorage */

import loginDetails from './logindetails'
import VueCookies from 'vue-cookies'

export default {
    // login (email, pass, loc, cb) {
    login (loc, cb) {
      cb = arguments[arguments.length - 1]
      if (localStorage.token) {
        if (cb) cb(true)
        this.onChange(true)
        return
      }
      // pretendRequest(email, pass, loc, (res) => {
      pretendRequest(loc, (res) => {
        if (res.authenticated) {
          localStorage.token = res.token
          if (cb) cb(true)
          this.onChange(true)
        } else {
          if (cb) cb(false)
          this.onChange(false)
        }
      })
    },
    // .substr(19)
    getLocation() {
      return VueCookies.get("token") ? VueCookies.get("location"): 'Guest';
    },

    getToken () {
      return localStorage.token ? localStorage.token: (VueCookies.get("token") ? VueCookies.get("token"): null)
    },

    logout (cb) {
      delete localStorage.token
      VueCookies.remove("token");
      VueCookies.remove("location");
      if (cb) cb()
      this.onChange(false)
    },

    loggedIn () {
      // return !!localStorage.token
      return !!this.getToken()
    },

    onChange () {}
  }

  // function pretendRequest (email, pass, loc, cb) {
  function pretendRequest (loc, cb) {
    setTimeout(() => {

      var checkMatch = false;
      for (var index in loginDetails) {
        if (
          // email === loginDetails[index]['username']  &&
          pass === 'dashboard' || 'Chukwuma123' // loginDetails[index]['password'] // &&
          //   loc === loginDetails[index]['location']
        ) {
          checkMatch = true;
        }
      }
      if (checkMatch) {

        if (pass === 'Chukwuma123') {
          localStorage.user_type = 'superadmin';
        }
        if (pass === 'dashboard') {
          localStorage.user_type = 'admin';
        }

        var loc = 'Admin';
        var authVals = {
          authenticated: true,
          token: Math.random().toString(36).substring(7) + new Date().getTime()+loc.trim().replace(/\s/g,'')
        }
        // set the tokens to the as the cookies value
        if (loc !== 'Guest') {
          VueCookies.set("token", authVals.token, "9m") // expires after 9 months
        }
        // set the location cookies
        if (VueCookies.isKey("location")) {
          VueCookies.remove("location"); // removing existing location
        }
        VueCookies.set("location", loc.trim().replace(/\s/g,''), -1); // set new location; -1 ~~ never expire
        // set the authval as the callback
        cb(authVals)
      } else {
        cb({ authenticated: false })
      }
    }, 0)
  }



// WEBPACK FOOTER //
// ./src/components/Auth/auth.js